import { render, staticRenderFns } from "./LogoSrcFlipper.vue?vue&type=template&id=06c06ea0&scoped=true"
import script from "./LogoSrcFlipper.vue?vue&type=script&lang=js"
export * from "./LogoSrcFlipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c06ea0",
  null
  
)

export default component.exports